








/* eslint-disable @typescript-eslint/camelcase */

import { Component, Prop, Vue } from "vue-property-decorator";

import { getCartePlaceListing_getCartePlaceListing_edges_node_requiredBy } from "../graphql/types/getCartePlaceListing";

@Component({
  components: {}
})
export default class ManufactureList extends Vue {
  @Prop()
  private requiredBy?: getCartePlaceListing_getCartePlaceListing_edges_node_requiredBy[];

  private get manufactures() {
    // sort manufactures alphabetically
    if (this.requiredBy) {
      this.requiredBy.sort((a, b) => {
        if (a?.name && b?.name) {
          return a.name.localeCompare(b.name);
        } else {
          return -1;
        }
      });
    }

    return this.requiredBy;
  }
}
